/**
 * Resolves the single-letter role code (`A`/`D`/`T`/`M`) from the auth `user` object.
 * Backend may serialize as camelCase (`useType`) or PascalCase (`UseType`).
 */
export function resolveUserRole(user: unknown): string {
  if (!user || typeof user !== 'object') return '';
  const u = user as Record<string, unknown>;
  const raw = (u['useType'] as string | undefined) ?? (u['UseType'] as string | undefined) ?? '';
  return raw.trim().toUpperCase().slice(0, 1);
}
